'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _styledComponents2.default.button.withConfig({
  componentId: 's1m3z0hq-0'
})(['cursor:pointer;-webkit-appearance:none;margin:calc(', ' * 1.5) 0 0;font-size:1em;line-height:inherit;font-family:inherit;border:none;color:', ';background-color:', ';border-radius:', ';padding:', ' ', ';transition:background-color 350ms ease;&:hover{background-color:', ';}', ' ', ''], function (p) {
  return p.theme.spacingUnit;
}, function (p) {
  return p.theme.buttonTextColor;
}, function (p) {
  return p.theme.buttonColor;
}, function (p) {
  return p.theme.borderRadius;
}, function (p) {
  return p.theme.buttonSpacingV;
}, function (p) {
  return p.theme.buttonSpacingH;
}, function (p) {
  return p.theme.buttonColorHover;
}, function (p) {
  return p.disabled && '\n    background-color: ' + p.theme.buttonColorDisabled + ';\n    cursor: default;\n\n    &:hover {\n      background-color: ' + p.theme.buttonColorDisabled + ';\n    }\n  ';
}, function (p) {
  return !p.primary && '\n    background-color: ' + p.theme.buttonSecondaryColor + ';\n    color: ' + p.theme.buttonSecondaryTextColor + ';\n  \n    &:hover {\n      background-color: ' + p.theme.buttonSecondaryColorHover + ';\n    }\n  ';
});